var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-new"
  }, [_c('div', {
    staticClass: "success"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/payicon.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "message blue"
  }, [_vm._v("订单提交成功")]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v("您需要将订单分享给客户")]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('mt-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_app_customer),
      expression: "is_app_customer"
    }],
    attrs: {
      "type": "primary",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.toPush
    }
  }, [_vm._v("推送到众赢财富通App")]), _vm._v(" "), _c('p', [_vm._v(" ")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.toShare
    }
  }, [_vm._v("分享给客户")])], 1)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.0.2@vue-loader/lib/template-compiler?{"id":"data-v-96f1a686","hasScoped":true}!./~/_vue-loader@13.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/order/OrderNewSuccess.vue
// module id = 250
// module chunks = 0